import React from "react";
import { Link } from "react-router-dom";
import { INVESTOR_POINTS } from "../lib/siteData";
import { ArrowRight, Globe2, TrendingUp, ShieldCheck, Landmark } from "lucide-react";
import Reveal from "./Reveal";

const ICONS = [Globe2, Landmark, ShieldCheck, TrendingUp];

export default function Investors() {
  return (
    <section
      className="relative bg-[#0A192F] text-white py-20 lg:py-28 overflow-hidden"
      data-testid="investors-section"
    >
      {/* BG image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_lnz-projects/artifacts/7kfpgtvz_highway.png"
          alt=""
          aria-hidden
          className="w-full h-full object-cover opacity-15"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F] via-[#0A192F]/95 to-[#0A192F]/75" />
        <div className="absolute inset-0 blueprint-grid-dark opacity-80 pointer-events-none" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left — headline */}
          <Reveal className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#F5A400]" />
              <span className="text-xs tracking-[0.3em] font-semibold text-[#F5A400]">INVESTORS &amp; DEVELOPERS</span>
            </div>
            <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] tracking-tight text-white">
              Build &amp; invest in Jamaica with confidence.
            </h2>
            <p className="mt-6 text-base lg:text-lg text-white/70 leading-relaxed">
              International investors, diaspora clients, real estate partners and commercial
              developers choose LNZ as their on-the-ground execution partner. One firm,
              end-to-end — from site acquisition to keys handed over.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4 max-w-md" data-testid="investor-audiences">
              {["International Investors", "Diaspora Clients", "Real Estate Partners", "Commercial Developers"].map(
                (a) => (
                  <div
                    key={a}
                    className="border border-white/15 p-4 text-sm font-semibold text-white/90 bg-white/5 backdrop-blur-sm"
                  >
                    {a}
                  </div>
                )
              )}
            </div>

            <Link
              to="/contact"
              className="mt-10 inline-flex items-center justify-center gap-2 bg-[#F5A400] text-[#0A192F] hover:bg-[#D99000] font-bold px-8 py-4 transition-all duration-300 hover:-translate-y-0.5"
              data-testid="investor-cta"
            >
              Build &amp; Invest in Jamaica With Confidence
              <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>

          {/* Right — points */}
          <Reveal className="lg:col-span-7" delay={120}>
            <div className="grid sm:grid-cols-2 gap-5" data-testid="investor-points-grid">
              {INVESTOR_POINTS.map((p, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <div
                    key={p.title}
                    className="group relative p-7 bg-white/5 backdrop-blur-md border border-white/10 hover:border-[#F5A400]/60 transition-all duration-500 hover:-translate-y-1"
                    data-testid={`investor-point-${p.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  >
                    <div className="w-11 h-11 flex items-center justify-center bg-[#F5A400] text-[#0A192F] mb-5">
                      <Icon className="w-5 h-5" />
                    </div>
                    <h3 className="font-display text-xl font-bold text-white mb-2 tracking-tight">{p.title}</h3>
                    <p className="text-sm text-white/70 leading-relaxed">{p.desc}</p>
                  </div>
                );
              })}
            </div>

            {/* Impact bar — two columns now */}
            <div className="mt-10 grid grid-cols-2 border-t border-white/15 pt-8 gap-6">
              <div>
                <div className="font-display text-3xl lg:text-4xl font-bold text-[#F5A400]">12+</div>
                <div className="text-[11px] tracking-[0.25em] uppercase font-semibold text-white/60 mt-1">Parishes Served</div>
              </div>
              <div>
                <div className="font-display text-3xl lg:text-4xl font-bold text-[#F5A400]">Zero</div>
                <div className="text-[11px] tracking-[0.25em] uppercase font-semibold text-white/60 mt-1">Compliance Failures</div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
